<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{this.route.menuName}}</span>
      </div>
      <div class="header">
        <div class="left">

          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData" v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>


      <el-tabs v-model="activeName" class="tabBox" @tab-click="tabClick">
        <el-tab-pane v-for="item in stockAgeMenu" :key="item.id" :name="item.id + ''">
          <template slot="label">
            <el-badge :value="item.count" :max="99" class="item">
              <span style="margin: 0 10px"> {{ item.name }} </span>
            </el-badge>
          </template>
        </el-tab-pane>
      </el-tabs>
      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
        <template slot="before">
          <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
          </el-table-column>
        </template>
          <template slot="after">
          </template>
        </CustomTable>
      </div>
      <div v-else>
        <el-table ref="multipleTable" border v-loading="loading" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
          <template slot="empty">
            <div class="empty-div" :style="{ height: tableHeight + 'px' }">
              <img src="../../../../assets/noData.png" width="240" height="240" />
              <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
              <div class="empty-rest" @click="reset">恢复默认</div>
            </div>
          </template>
          <el-table-column prop="supplierProductNo" width="170" label="供应商产品编码" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.supplierProductNo?scope.row.supplierProductNo:'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="productName" width="150" label="产品名称" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.productName?scope.row.productName:'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="specName" width="100" label="规格/型号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="warehouseName" width="100" label="库房" show-overflow-tooltip></el-table-column>
          <el-table-column prop="mainNo" width="100" label="主条码" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.mainNo?scope.row.mainNo:'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="traceNo" width="100" label="溯源码" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.traceNo?scope.row.traceNo:'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="bookStock" width="80" label="账面数量"></el-table-column>
          <el-table-column prop="stockQuantity" width="80" label="库存数量"></el-table-column>
          <el-table-column prop="minUnit" width="80" label="最小单位"></el-table-column>
          <el-table-column prop="unit" width="80" label="包装单位">
            <template slot-scope="scope">
              {{scope.row.unit?scope.row.unit:'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="price" width="80" label="采购价"></el-table-column>
          <el-table-column prop="billingPrice" width="80" label="计费价"></el-table-column>
          <el-table-column prop="amount" width="80" label="小计"></el-table-column>
          <el-table-column prop="stockCategoryName" width="120" label="库存类别"></el-table-column>
          <el-table-column prop="locationName" width="100" label="货位" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.locationName?scope.row.locationName:'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="productRegistCertNo" width="100" label="注册证号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="productRegistCertName" width="150" label="注册证名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="manufacturerName" width="150" label="生产厂家" show-overflow-tooltip></el-table-column>
          <el-table-column prop="supplierName" width="150" label="供应商" show-overflow-tooltip></el-table-column>
          <el-table-column prop="batch" width="100" label="批号" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.batch?scope.row.batch:'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="manufactureDate" width="120" label="生产日期">
            <template slot-scope="scope">{{ scope.row.manufactureDate?parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}"):'-' }}</template>
          </el-table-column>
          <el-table-column prop="validityDate" width="120" label="有效期">
            <template slot-scope="scope">{{ scope.row.validityDate?parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}"):'-' }}</template>
          </el-table-column>
          <el-table-column prop="longTime" label="长期" width="60">
            <template slot-scope="scope">
              {{ scope.row.longTime == 1 ? "是" : "否"}}
            </template>
          </el-table-column>
          <el-table-column prop="serialNo" width="100" label="序列号" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.serialNo?scope.row.serialNo:'-'}}
            </template>
          </el-table-column>
  
          <el-table-column  prop="createdDate" min-width="100" label="入库日期" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.createdDate?parseTime(new Date(scope.row.createdDate), "{y}-{m}-{d}"):'-' }}
            </template>
          </el-table-column>
          <el-table-column prop="stockAge" min-width="100" label="库龄（天）" show-overflow-tooltip></el-table-column>
  
          <el-table-column prop="onlineNo" width="100" label="挂网号" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.onlineNo?scope.row.onlineNo:'-'}}
            </template>
          </el-table-column>
          <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码" width="200"></el-table-column>
        </el-table>
      </div>
 

    </div>
    <div class="pagination">
      <span style="float: left">金额合计(元)：{{ totalAmount }}元</span>
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import {
  GetStocksWithAge,
  ExportStockWithAge,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import { StockCategoryOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from '@/mixin/baseList-mixin.js'

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      GetDatasAction: GetStocksWithAge,
      exportAction: ExportStockWithAge,
      StockCategoryOptions: StockCategoryOptions,
      activeName: 0,
      filterOptions: [
    
        {
          name: "产品名称",
          type: "input",
          code: "productName"
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName"
        },
        {
          name: "库房",
          type: "select",
          code: "warehouseId",
          filterMethod: this.getWarehouses,
          data: [],
        },
        {
          name: "库存类别",
          type: "select",
          code: "category",
          data: StockCategoryOptions,
          defaultValue: this.$route.params ? '' : 0
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo"
        },
        {
          name: "供应商",
          type: "select",
          code: "supplierId",
          filterMethod: this.getSuppliers,
          data: [],
        },
        {
          name: "入库日期（范围）",
          type: "date",
          code: "date",
          defaultValue: [this.$route.params.startDate || '', this.$route.params.endDate || ''],
          startDateCode: "stockInStartDate",
          endDateCode: 'stockInEndDate'
        },
        
        {
          name: "注册证号",
          type: "input",
          code: "productRegistCertNo",
        },
        {
          name: "主条码",
          type: "input",
          code: "mainNo",
        },
        {
            name: "库龄（范围）",
            type: "numberRange",
            startCode: 'stockAgeMoreDays',
            endCode: 'stockAgeLessDays'
          },
      ],
      stockAgeMenu:[]
    };
  },
  methods: {
    tabClick (val) {
      this.query.stockAgeSettingId = val.name
      this.getData();
    },

  },
  mounted () {
    this.$set(this.$refs["selectFilter"].query, "category", 0)
    this.$set(this.$refs["selectFilter"].query, "categoryName", '普通')
    if (this.$route.params && this.$route.params.startDate) {
      this.$refs["selectFilter"].query.category = ''
      this.$set(this.$refs["selectFilter"].query, "categoryName", '')
    }
  },
  created () {
    // this.query.category = 0
    this.$set(this.query, "category", 0)
    if (this.$route.params && this.$route.params.startDate) {
      this.query.startDate = this.parseTime(this.$route.params.startDate)
      this.query.endDate = this.parseTime(this.$route.params.endDate)
      this.query.category = ''
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-badge__content.is-fixed {
  top: 10px !important;
  right: 12px !important;
}

</style>
